"use client";

import { Accordion as AccordionPrimitive } from "@base-ui/react/accordion";
import { NavArrowDown } from "iconoir-react";
import * as React from "react";

import { cn } from "@/lib/utils";

function Accordion({
  className,
  keepMounted = true,
  ...props
}: AccordionPrimitive.Root.Props) {
  return (
    <AccordionPrimitive.Root
      className={cn(className)}
      keepMounted={keepMounted}
      {...props}
    />
  );
}

const AccordionItem = React.forwardRef<
  HTMLDivElement,
  AccordionPrimitive.Item.Props
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border-grey-100 border-b", className)}
    {...props}
  />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTriggerWithoutIcon = React.forwardRef<
  HTMLButtonElement,
  AccordionPrimitive.Trigger.Props
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="col-span-full grid grid-cols-subgrid">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "group col-span-full flex flex-1 items-center justify-between py-4 font-medium transition-all [&[data-panel-open]>svg]:rotate-45",
        className
      )}
      {...props}
    >
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTriggerWithoutIcon.displayName = "AccordionTriggerWithoutIcon";

const AccordionTrigger = React.forwardRef<
  HTMLButtonElement,
  AccordionPrimitive.Trigger.Props
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "text-ds-body-sm text-grey-950 flex flex-1 items-center justify-between py-4 text-left font-medium transition-all hover:underline [&[data-panel-open]>svg]:rotate-180",
        className
      )}
      {...props}
    >
      {children}
      <NavArrowDown className="text-grey-500 h-4 w-4 shrink-0 transition-transform duration-200" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = "AccordionTrigger";

const AccordionContent = React.forwardRef<
  HTMLDivElement,
  AccordionPrimitive.Panel.Props
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Panel
    ref={ref}
    className={cn(
      "text-ds-body-sm data-closed:animate-accordion-up data-open:animate-accordion-down overflow-hidden"
    )}
    {...props}
  >
    <div
      className={cn(
        "pt-0 pb-4 data-ending-style:h-0 data-starting-style:h-0",
        className
      )}
    >
      {children}
    </div>
  </AccordionPrimitive.Panel>
));
AccordionContent.displayName = "AccordionContent";

export {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionTriggerWithoutIcon,
  AccordionContent,
  AccordionPrimitive,
};
